import CronShow from './cron.show';

export default {
  show: CronShow,
};
